export default "__VITE_ASSET__6s3A0z89__"